// extracted by mini-css-extract-plugin
export default {"ReviewDone":"ReviewDone_ReviewDone__hA5hS","IconCheck":"ReviewDone_IconCheck__sj+yJ"};